import initialState from './initialState';
import { fetchReducerFactory } from '../../../shared/store/fetchFactory';
import {
  CREATE_SCENARIO,
  UPDATE_SCENARIO,
  REMOVE_SCENARIO,
  UPDATE_SCENARIO_LIST_COLUMN_STATE,
} from './types';


const fetchReducer = fetchReducerFactory({
  [CREATE_SCENARIO]: 'ScenarioCreate',
  [UPDATE_SCENARIO]: 'ScenarioUpdate',
  [REMOVE_SCENARIO]: 'ScenarioRemove',
}, initialState);


const scenariosListReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_SCENARIO_LIST_COLUMN_STATE:
      return {
        ...state,
        columnState: action.newColumnState,
      };
    default: {
      return fetchReducer(state, action);
    }
  }
};


export default scenariosListReducer;
